import { Phone, MapPin, Navigation, CalendarCheck, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function HittaHit() {
  return (
    <main className="pt-28 md:pt-36 pb-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono-brand text-xs md:text-sm tracking-[0.3em] text-electric mb-4">HITTA HIT</p>
          <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white">
            Kom förbi — <span className="text-gradient-blue">vi visar gärna</span>
          </h1>
          <p className="mt-4 max-w-xl text-slate-400">
            Vår lokal ligger på {SITE.address}, {SITE.zip}. Ring oss eller boka en visningstid så hittar
            vi en tidpunkt som passar dig.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.6fr_1fr] items-stretch">
          <Reveal className="h-full">
            <div className="h-full rounded-2xl overflow-hidden border border-metallic/70 bg-surface" data-testid="map-container">
              <iframe
                title="Karta till Borås Fritid, Viaredsvägen 43E, Borås"
                src={SITE.mapsEmbed}
                className="map-frame w-full h-full min-h-[380px] lg:min-h-[460px]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>

          <div className="flex flex-col gap-6">
            <Reveal delay={0.1}>
              <div className="rounded-2xl border border-metallic/70 bg-surface p-8" data-testid="address-card">
                <MapPin size={24} className="text-electric" />
                <h2 className="mt-4 font-display font-bold text-xl text-white">Adress</h2>
                <p className="mt-2 text-slate-300 leading-relaxed">
                  {SITE.address}
                  <br />
                  {SITE.zip}
                </p>
                <a
                  href={SITE.mapsDirections}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="directions-button"
                  className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white hover:bg-brand-dark transition-colors"
                >
                  <Navigation size={15} />
                  Vägbeskrivning
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="rounded-2xl border border-metallic/70 bg-surface p-8" data-testid="phone-card">
                <Phone size={24} className="text-electric" />
                <h2 className="mt-4 font-display font-bold text-xl text-white">Ring oss</h2>
                <a
                  href={`tel:${SITE.phone}`}
                  data-testid="phone-card-link"
                  className="mt-2 block font-mono-brand text-lg text-white hover:text-electric transition-colors"
                >
                  {SITE.phoneDisplay}
                </a>
                <p className="mt-2 text-sm text-slate-400">Vi tar emot visningar endast efter tidsbokning — dygnet runt.</p>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="rounded-2xl border border-metallic/70 bg-surface p-8" data-testid="hours-card">
                <Clock size={24} className="text-electric" />
                <h2 className="mt-4 font-display font-bold text-xl text-white">Öppettider</h2>
                <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-brand/15 border border-brand/30 px-4 py-1.5 text-sm font-semibold text-electric" data-testid="hours-badge">
                  Endast tidsbokning · dygnet runt
                </p>
                <p className="mt-3 text-sm text-slate-400">
                  Vi tar emot visningar endast efter tidsbokning — boka din tid när det passar dig, dygnet
                  runt. Ring oss eller boka online, så möter vi dig på Viaredsvägen.
                </p>
              </div>
            </Reveal>

          </div>
        </div>
      </div>
    </main>
  );
}
